export const types = <const>{
	mutations: {
		VOZIDLA_PUJCOVNY_VOZIDLO_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_VOZIDLO_SELECT_MAPPER', // vozidlo mapper from List component
		VOZIDLA_PUJCOVNY_PRAC_UZIVATEL_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_PRAC_UZIVATEL_SELECT_MAPPER',
		VOZIDLA_PUJCOVNY_PRAC_TECHNIK_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_PRAC_TECHNIK_SELECT_MAPPER',
		VOZIDLA_PUJCOVNY_VSTUP_PRAC_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_VSTUP_PRAC_SELECT_MAPPER',
		VOZIDLA_PUJCOVNY_VOZIDLO_MAPPER: 'VOZIDLA_PUJCOVNY_VOZIDLO_MAPPER', // vozidlo mapper from Edit component
		VOZIDLA_PUJCOVNY_PRACOVNIK_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_PRACOVNIK_SELECT_MAPPER',
		VOZIDLA_PUJCOVNY_TECHNIK_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_TECHNIK_SELECT_MAPPER',
		VOZIDLA_PUJCOVNY_NAKLADOVE_STREDISKO_SELECT_MAPPER: 'VOZIDLA_PUJCOVNY_NAKLADOVE_STREDISKO_SELECT_MAPPER',
		VOZIDLO_SELECT_ZMENA: 'VOZIDLO_SELECT_ZMENA',
	},
	actions: {
		VOZIDLO_SELECT_ZMENA: 'VOZIDLO_SELECT_ZMENA',
	},
};
